module.exports = __webpack_public_path__ + "static/media/tutorial-macros-step3.dec8586f.png";